import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import ArticleList from '../article-list';
import Button from '@material-ui/core/Button';
import article from '../article-list/article';
import { map } from 'core-js/fn/array';
import Grid from '@material-ui/core/Grid';

function groupBy(list, props) {
  return list.reduce((a, b) => {
    const result = a;
    (result[b[props]] = result[b[props]] || []).push(b);
    return result;
  }, {});
}

class Sidebar extends Component {

  getArticleList(articles) {
    const { localSettings, productionPlaces } = this.props;

    const groupByProductionPlaces = !!localSettings.showProductionPlaceFilter;

    if (groupByProductionPlaces) {
      const groups = groupBy(articles, 'productionPlaceId');

      return Object.keys(groups).map((groupKey) => {
        const productionPlace = productionPlaces.find(x => x.productionPlaceId == groupKey);
        return (
          <div>
            <h2>{productionPlace ? productionPlace.name : ''}</h2>
            <ArticleList
              value={groups[groupKey]}
            />
          </div>
        );
      })
    }

    return (
      <ArticleList
        value={articles}
      />
    );
  }
  render() {
    const { classes, printArticleList, isEPosPrinterEnabled } = this.props;

    // const articleCounts = this.props.orders
    //   .flatMap(o => o.articles)
    //   .reduce((accumulator, current) => {
    //     const currentValue = accumulator[current.name] || 0;
    //     // eslint-disable-next-line no-param-reassign
    //     accumulator[current.name] = currentValue + current.quantity;
    //     return accumulator;
    //   }, {});

    // const articles = Object.keys(articleCounts).map(k => ({
    //   name: k,
    //   quantity: articleCounts[k],
    // }));


    const articlemap = new Map();

    this.props.orders
      .forEach(order =>
        order.articles.forEach((article) => {
          const articlefeatures = article.features ? article.features.join(', ') : null;
          const articlenNameWithFeatures = article.name + articlefeatures;

          let currentValue = articlemap.get(articlenNameWithFeatures);

          if (typeof currentValue === 'undefined') {
            currentValue = {
              name: article.name,
              features: article.features,
              quantity: 0,
              productionPlaceId: order.productionPlaceId,
            };
          }

          currentValue.quantity += article.quantity;


          articlemap.set(articlenNameWithFeatures, currentValue);
        }),
      );

    const articles = [];

    for (const article of articlemap.values()) {
      articles.push({
        name: article.name,
        quantity: article.quantity,
        features: article.features,
        productionPlaceId: article.productionPlaceId
      });
    }

    return (
      <div className={classes.root} >
        <div
          className={classes.articleList}
        >
          {this.getArticleList(articles)}
        </div>
        {isEPosPrinterEnabled ?
          <div className={classes.buttonsContainer}>
            <Button
              variant="outlined"
              className={classes.button}
              onClick={() => printArticleList(articles)}
            >Artikelliste drucken</Button>
            {/* {this.renderRouteButtons()} */}
          </div>
          : null}
      </div>
    );
  }

  // renderRouteButtons() {
  //   const { classes, selectedMode, editRoutePlanning, finishRoutePlanning, isRoutePlanning, openRouteDialog } = this.props;
  //   if (selectedMode === "Route") {
  //     return (
  //       <div className={classes.routeButtonsContainer}>
  //         <Button
  //           variant="outlined"
  //           className={classes.button}
  //           onClick={isRoutePlanning ? finishRoutePlanning : editRoutePlanning}
  //         >{isRoutePlanning ? "Route speichern" : "Route bearbeiten"}
  //         </Button>
  //         <Button
  //           variant="outlined"
  //           className={classes.button}
  //           onClick={() => {
  //             if (isRoutePlanning)
  //               finishRoutePlanning()

  //             openRouteDialog();

  //           }}
  //         >Route berechnen
  //       </Button>
  //       </div>
  //     );
  // }
  // }
}

const styles = theme => ({
  root: {
    // "box-shadow": "0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12)",
    // "background-color": "#f5f5f5",
    display: 'flex',
    'flex-direction': 'column',
    height: `calc(100vh - ${theme.header.height}px )`,
    justifyContent: 'space-between',
  },
  articleList: {
    // "flex-basis": "100%",
    overflowY: 'auto',
    overflowX: 'hidden',
  },
  button: {
    fontSize: theme.order.buttons.fontSize,
    margin: '2px',
    flexGrow: 1,
  },
  routeButtonsContainer: {
    display: 'flex',
  },
  buttonsContainer: {
    display: 'flex',
    flexWrap: 'wrap',
  },
});

Sidebar.propTypes = {
  classes: PropTypes.object.isRequired,
  orders: PropTypes.array.isRequired,
  productionPlaces: PropTypes.array.isRequired,
  selectedMode: PropTypes.string.isRequired,
  finishRoutePlanning: PropTypes.func.isRequired,
  editRoutePlanning: PropTypes.func.isRequired,
  isRoutePlanning: PropTypes.bool.isRequired,
  openRouteDialog: PropTypes.func.isRequired,
  isEPosPrinterEnabled: PropTypes.bool.isRequired,
  localSettings: PropTypes.object.isRequired,
};


export default withStyles(styles)(Sidebar);
